<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索文字..."
          @on-change="searchTask"
          clearable
          icon="ios-search"
          style="width: 250px"
        >
        </Input>
        <RadioGroup v-model="filterQuery.category" type="button" style="margin-left: 8px" @on-change="loadTask(0)">
            <Radio label="all">全部</Radio>
            <Radio label="sales">销售</Radio>
            <Radio label="research">研发</Radio>
            <Radio label="techservice">技服</Radio>
            <Radio label="factory">厂务</Radio>
            <Radio label="shipping">运输</Radio>
            <Radio label="fin">财务</Radio>
            <Radio label="office">总经办</Radio>
        </RadioGroup>
        <RadioGroup v-model="filterQuery.progress" type="button" style="margin-left: 8px" @on-change="loadTask(0)">
            <Radio label="all">全部</Radio>
            <Radio label="created">未完成</Radio>
            <Radio label="finished">已完成</Radio>
            <Radio label="canceled">取消</Radio>
        </RadioGroup>
        <Button style="margin-left: 12px" @click="$refs.TaskeCategoryModal.openModal()">权限</Button>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="50"
          @on-change="loadTask"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button
          type="primary"
          @click="showNewTask = true"
          >新增任务</Button
        >
      </div>
    </div>
    <div class="task-wrapper">
      <div class="task-area">
        <div class="new-task-area" v-if="showNewTask">
          <div class="new-task-input-area">
            <h2 style="width: 170px">新任务：</h2>

            <Select v-model="newTask.mainResponsible" filterable style="width: 170px">
                <Option v-for="user in simpleUserList" :value="user._id" :key="user._id">{{ user.name }}</Option>
            </Select>
            
            <Input
              ref="input-title"
              v-model="newTask.title"
              placeholder="任务"
              @on-enter="createNewTask"
              ></Input>

            <Input
              ref="input-deadLine"
              style="width: 170px"
              v-model="newTask.deadLine"
              placeholder="截止时间"
              @on-enter="createNewTask"
              ></Input>
          </div>
          
          <div class="new-task-btn-area">
            <Button @click="createNewTask" size="small" type="primary">保存</Button>
            <Button @click="showNewTask = false" size="small">取消</Button>
          </div>
        </div>

        <div class="task-title">
          <div class="col">
            创建日期
          </div>
          <div class="col">
            负责人
          </div>
          <div class="col" style="width: 590px">
            内容
          </div>
          <div class="col">
            截止日期
          </div>
          <div class="col">
            进度
          </div>
          <div class="col">
            类型
          </div>          
          <div class="col">
            创建人
          </div>
        </div>

        <div v-for="task in taskList">
          <TaskBox :task="task"/>
        </div>
      </div>
      
    </div>
    <EditTaskDrawer ref="EditTaskDrawer" />
    <TaskeCategoryModal ref="TaskeCategoryModal" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import EditTaskDrawer from "./EditTaskDrawer.vue";
import TaskBox from "./TaskBox.vue";
import TaskeCategoryModal from "./TaskeCategoryModal.vue";


import _ from "lodash";

const typesText = {
  MonthlySalesPlan: "月销售",
  MonthlyReceivePlan: "月回款",
  SalesWeeklyReport: "销售周报",
};
const progressText = {
  created: "创建",
  inProgress: "进行中",
  reviewing: "审查中",
  finished: "完成",
  abandoned: "放弃",
  failed: "失败",
};

export default {
  name: "Task",
  components: { EditTaskDrawer, TaskBox, TaskeCategoryModal },
  data() {
    return {
      page: 0,
      limit: 50,
      searchText: "",
      tableLoading: false,
      tableData: [],
      filterQuery: {
        category: 'all',
        progress: 'all',
      },
      showNewTask: false,
      newTask: {
        mainResponsible: null,
        title: '',
        deadLine: null,
      },
      isEditing: false
    };
  },
  computed: mapState({
    totalRows: (state) => state.task.totalCounts,
    taskList: (state) => state.task.taskList,
    currentUser: (state) => state.auth.currentUser,
    simpleUserList: (state) => state.user.simpleUserList,
  }),
  methods: {
    ...mapActions({
      getSimpleUserList: "user/getSimpleUserListAction",
      getTaskList: "task/getTaskListAction",
      createTask: "task/createTaskAction",
      updateTask: "task/updateTaskAction",
    }),
    async loadTask(page) {
      if (page) this.page = page - 1;
      const query = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      if (query.progress === 'all') delete query.progress;
      if (query.category === 'all') delete query.category;
      try {
        this.tableLoading = true;
        await this.getTaskList(query);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchTask: _.debounce(function () {
      this.page = 0;
      this.loadTask();
    }, 1000),
    async createNewTask() {
      if (this.newTask.title.trim() === '') {
        return this.$Message.info('不能创建空白任务')
      }
      const newTaskData = {
        title: this.newTask.title,
        type: 'custom'
      }
      if (this.newTask.mainResponsible) {
        newTaskData.mainResponsible = this.newTask.mainResponsible;
      }
      
      if (this.newTask.deadLine) {
        const dlText = this.newTask.deadLine.trim();
        if (dayjs(dlText).isValid()) {
          newTaskData.deadLine = dayjs(dlText);
          if (newTaskData.deadLine.year() === 2001) {
            const currentYear = dayjs().year();
            newTaskData.deadLine = dayjs(dlText).year(currentYear);
          }
        } else {
          console.log('invalid date');
        }
      }
      await this.createTask(newTaskData);
      this.newTask.title = '';
    },
    // openEditTaskDrawer() {
    //   this.$refs.EditTaskDrawer.openDrawer();
    // },
    keyDownHandler(e) {
      // console.log(e.key);
      if (e.key === 'Escape') {
        this.showNewTask = false;
      }
    }
  },
  async created() {
    window.addEventListener('keydown', this.keyDownHandler)
    await this.getSimpleUserList({ limit: 999 });
    this.loadTask();
  },
  mounted() {

  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
};
</script>
<style lang="stylus" scoped>
.container
  overflow-y auto

.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.task-wrapper
  width 100%
  height calc(100% - 48px)
  display flex
  justify-content center

.task-area
  width 1000px
  @media screen and (max-width: 1000px)
    width 100%

.new-task-area
  background-color #ececec
  padding 8px
  margin-bottom 12px
  border-radius 4px
.new-task-input-area
  margin 8px
  display flex
  gap 8px
  align-items center

.new-task-btn-area
  margin 8px
  display flex
  gap 8px
  justify-content flex-end

.task-title
  display flex
.col
  width 64px
  padding-left 6px
  border 1px solid white
</style>